import { combineReducers } from "redux";
import clients from "./clients";

const adminRootReducer = combineReducers({
  clients,
});

export default adminRootReducer;
